import { concat, Observable, tap, take, share, MonoTypeOperatorFunction } from 'rxjs';

export function tapOnce<T>(functionToTap: (obs: T) => unknown): MonoTypeOperatorFunction<T> {
	return (source$: Observable<T>) => {
		const shared$ = source$.pipe(share());
		const tapped$ = shared$.pipe(tap(functionToTap), take(1));

		return concat(tapped$, shared$);
	};
}
